import React, { Component } from 'react';
import Combobox from 'react-widgets/lib/Combobox'
class OpenpayDetaild extends Component {

	//------------------------------------------INIT-----------------------------

	constructor(props) {
		super(props);
		this.state = {
			innerBranchId: {
				nombre: null,
				innerBranchId: null
			},
			errorInnerBranchId: "",
			openpayCredentials: {
				razon_social: null
			},
			errorOpenpayCredentials: "",
			_id: null,
		};
		this.sendData = this.sendData.bind(this);
		this.onPressDelete = this.onPressDelete.bind(this);
		this.onChangeInnerBranchId = this.onChangeInnerBranchId.bind(this);
		this.onChangeOpenpayCredentials = this.onChangeOpenpayCredentials.bind(this);
		this.onPressCancel = this.onPressCancel.bind(this);
		this.onPressEsc = this.onPressEsc.bind(this);
	}

	componentDidUpdate(prevProps) {
		document.addEventListener('keydown', this.onPressEsc, false);
		if (this.props.visible !== prevProps.visible) {
			if (this.props.visible && this.props.dataField?.innerBranchId) {
				this.setState({
					innerBranchId: { nombre: this.props.dataField.nombre, innerBranchId: this.props.dataField.innerBranchId },
					openpayCredentials: this.props.dataField.razon_social,
					_id: this.props.dataField._id,
				})
			}
		}
	}

	onPressEsc(event) {
		if (event.keyCode === 27) {
			this.onPressCancel();
		}
	}

	//------------------------------------------EVENTS-----------------------------

	sendData() {
		if (this.verifyForm()) {
			this.props.onPressSave(
				{
					innerBranchId: this.state.innerBranchId.innerBranchId,
					razon_social: this.state.openpayCredentials.razon_social,
					_id: this.state._id,
				}
			)
			this.clearState();
			this.farmazonFormRef.reset();
		}
	}

	onChangeInnerBranchId = (data) =>
		this.setState({
			innerBranchId: data
		});

	onChangeOpenpayCredentials = (data) =>
		this.setState({
			openpayCredentials: data
		});

	clearState = () => {
		this.setState({
			innerBranchId: {
				nombre: null,
				innerBranchId: null
			},
			errorInnerBranchId: "",
			openpayCredentials: {
				razon_social: null
			},
			errorOpenpayCredentials: "",
			_id: null,
		})
	}

	onPressCancel() {
		this.farmazonFormRef.reset();
		this.clearState()
		this.props.onPressCancel()
	}

	onPressDelete() {
		this.props.onPressDelete(this.state._id)
		this.farmazonFormRef.reset();
		this.clearState()
	}

	//------------------------------------------VALIDATIONS-----------------------------

	verifyForm() {
		let errorInnerBranchId = null;
		let isValidInnerBranchId = true;
		let errorOpenpayCredentials = null;
		let isValidOpenpayCredentials = true;

		//Verificar centro
		if (!this.state.innerBranchId) {
			errorInnerBranchId = "Seleccione un centro."
			isValidInnerBranchId = false
		}
		if (!this.state.innerBranchId.innerBranchId) {
			errorInnerBranchId = "Seleccione un centro."
			isValidInnerBranchId = false
		}

		//Verificar credenciales
		if (!this.state.openpayCredentials) {
			errorOpenpayCredentials = "Seleccione una credencial."
			isValidOpenpayCredentials = false
		}

		if (isValidInnerBranchId && isValidOpenpayCredentials) return true
		else {
			this.setState({
				isValidInnerBranchId: isValidInnerBranchId,
				errorInnerBranchId: errorInnerBranchId,
				isValidOpenpayCredentials: isValidOpenpayCredentials,
				errorOpenpayCredentials: errorOpenpayCredentials,
			})
			return false
		}
	}


	//------------------------------------------VIEW-----------------------------
	render() {
		return (
			<div className={this.props.visible ? "modal display-block" : "modal display-none"}>
				<div className="modal-user-main">
					<form ref={(el) => { this.farmazonFormRef = el }} id={"form"} >
						<div
							key='1'
							className="card-form"
						>

							<div className="auth-label"></div>
							<div className="auth-label"></div>
							{!this.state._id &&
								<div className="auth-label textfield-rfc">Centro Farmazon:
									<span className="required">*</span>
								</div>
							}
							<div className="row-multiselect-center order-combobox">
								{
									this.props.visible && !this.state._id &&
									<Combobox
										autoFocus
										className="select-center"
										filter='contains'
										data={this.props.centersWithoutOpenpay}
										textField='nombre'
										form={"form"}
										defaultValue={this.state.innerBranchId.nombre}
										placeholder={this.state.innerBranchId.nombre ? this.state.innerBranchId.nombre : "Seleccione un centro"}
										onChange={this.onChangeInnerBranchId}
									/>
								}
							</div>
							<div className="auth-error">
								{this.state.errorInnerBranchId}
							</div>

							<div className="auth-label textfield-rfc">Credenciales:
								<span className="required">*</span>
							</div>
							<div className="row-multiselect-center order-combobox">
								{
									this.props.visible &&
									<Combobox
										autoFocus
										className="select-center"
										filter='contains'
										data={this.props.openpayCredentials}
										textField='razon_social'
										form={"form"}
										defaultValue={this.state.openpayCredentials.razon_social}
										placeholder={this.state.openpayCredentials.razon_social ? this.state.openpayCredentials.razon_social : "Seleccione una credencial"}
										onChange={this.onChangeOpenpayCredentials}
									/>
								}
							</div>
							<div className="auth-error">
								{this.state.errorInnerBranchId}
							</div>


							<div className="auth-label"></div>
							<div className="auth-label"></div>


						</div>
					</form>
					<div className="modal-activity-section">
						<button className="modal-buttonOK" onClick={this.sendData}>
							{this.state._id ? "Actualizar" : "Asociar"}
						</button>
						{
							this.state._id &&
							<button className="modal-buttonDelete" onClick={this.onPressDelete}>
								Eliminar
							</button>
						}
						<button
							className="modal-buttonNo"
							onClick={this.onPressCancel}
						>
							Cerrar
						</button>
					</div>
				</div>
			</div>
		)
	}
}

export default OpenpayDetaild;